import { CtaReassurance, FreeAuditButton } from "@/components/ui/Cta";
import { SectionHeader } from "@/components/ui/SectionHeader";
import { useContent } from "@/data/content";

export function ProcessSection() {
  const { process } = useContent().home;
  const last = process.steps.length - 1;

  return (
    <section id="proceso" aria-labelledby="process-heading" className="bg-teal-soft">
      <div className="mx-auto max-w-7xl px-4 py-24 sm:px-6 md:py-32 lg:px-8">
        <SectionHeader id="process-heading" title={process.title} lead={process.subtitle} />

        <ol className="mt-16 grid gap-10 md:grid-cols-3 md:gap-10">
          {process.steps.map((step, i) => (
            <li
              key={step.title}
              data-reveal=""
              style={{ ["--reveal-delay" as string]: `${i * 110}ms` }}
              className="group/step relative flex gap-5 md:flex-col md:gap-6"
            >
              {/* Connector to the next step only: the sequence ends at the last circle. */}
              {i < last ? (
                <span
                  aria-hidden="true"
                  data-ray="vertical-mobile"
                  style={{ ["--reveal-delay" as string]: `${200 + i * 110}ms` }}
                  className="absolute left-[1.375rem] top-[1.375rem] h-[calc(100%+2.5rem)] w-px bg-brand-secondary/60 md:h-px md:w-[calc(100%+2.5rem)]"
                />
              ) : null}
              <span
                aria-hidden="true"
                className="relative z-10 grid size-11 shrink-0 place-items-center rounded-full border-2 border-brand-secondary bg-white font-display text-lg font-semibold leading-none text-brand-primary shadow-[0_0_0_6px_var(--color-teal-soft)] transition-[background-color,color,transform] duration-300 [font-variant-numeric:lining-nums_tabular-nums] group-hover/step:bg-brand-secondary motion-safe:group-hover/step:scale-110"
              >
                {i + 1}
              </span>
              <div>
                <h3 className="font-display text-xl font-semibold leading-snug text-brand-primary">{step.title}</h3>
                <p className="mt-2 leading-relaxed text-ink-soft">{step.desc}</p>
              </div>
            </li>
          ))}
        </ol>

        <div data-reveal="" className="mt-14">
          <FreeAuditButton location="process" />
          <CtaReassurance className="mt-3" />
        </div>
      </div>
    </section>
  );
}
